export default function AudioContent(props:{url:string}) {
    return <audio controls>
        <source src={props.url}/>
    </audio>
}